/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wry_Bright_Frog_FlyInputs */

const en_wry_bright_frog_fly = /** @type {(inputs: Wry_Bright_Frog_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment analysis`)
};

const de_wry_bright_frog_fly = /** @type {(inputs: Wry_Bright_Frog_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentaranalyse`)
};

/**
* | output |
* | --- |
* | "Comment analysis" |
*
* @param {Wry_Bright_Frog_FlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wry_bright_frog_fly = /** @type {((inputs?: Wry_Bright_Frog_FlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wry_Bright_Frog_FlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wry_bright_frog_fly(inputs)
	return de_wry_bright_frog_fly(inputs)
});